module.exports = __webpack_public_path__ + "img/rivet.3ae58e03.svg";